import { FormulaConditionJson, LogicType } from '@doss/common-all'
import { Box, Typography } from '@mui/material'
import useStyles from '~/common/hooks/useStyles'
import { ConditionExpressionRenderer } from '../logic-expression/ConditionExpressionRenderer'
import { FormulaExpression } from './FormulaExpression'
import { FormulaKeyword } from './FormulaKeyword'

export interface FormulaConditionExpressionProps {
  data: FormulaConditionJson
  isFirst: boolean
  isLast: boolean
}

function getStyles() {
  return {
    container: {
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
      whiteSpace: 'nowrap',
    },
  }
}

/**
 * Renders a formula condition
 */
export function FormulaConditionExpression({
  data,
  isFirst,
  isLast,
}: FormulaConditionExpressionProps) {
  const styles = useStyles(getStyles)

  const checkIsLastConditionElse = (condition: FormulaConditionJson) => {
    const castedConditionExpression = condition.condition

    return castedConditionExpression.type === LogicType.BOOLEAN && castedConditionExpression.value
  }

  let conditionKeyword = 'IF'

  if (!isFirst && (!isLast || !checkIsLastConditionElse(data))) {
    conditionKeyword = 'ELSE IF'
  }

  if (isLast && checkIsLastConditionElse(data)) {
    conditionKeyword = 'ELSE'
  }

  return (
    <Box sx={styles.container}>
      {!isFirst && <Typography>;</Typography>}
      <Typography>
        <FormulaKeyword>{conditionKeyword}</FormulaKeyword>(
      </Typography>
      <ConditionExpressionRenderer data={data.condition} />
      <Typography>, </Typography>
      <FormulaExpression data={data.formula} />
      <Typography>)</Typography>
    </Box>
  )
}
